var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"primary","small":!_vm.text,"dense":!_vm.text,"text":_vm.text,"to":{name: _vm.routeName, query: { uuid: _vm.customer.uuid, type: 'customer' } }}},[_c('v-icon',{attrs:{"dense":""}},[_vm._v("mdi-star-check-outline")]),(!_vm.icon)?_c('span',[_vm._v(_vm._s(_vm.$t(_vm.title)))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }